/* Frontend JS - Fix escaped HTML in registration modal popups, whitespace & prevent form validation on close */
jQuery(function ($) {
	'use strict';

	function fixModalButtonsAndHtml() {
		// Ensure modal close buttons are type="button" so they do NOT trigger HTML5 form validation or form submission inside registration form
		$('.wkcv-close-modal, .wkcv-hide-terms, .wkcv-hide-policies, .wkcv-term-popup button, .wkcv-policy-popup button').each(function () {
			if (!$(this).attr('type') || $(this).attr('type') === 'submit') {
				$(this).attr('type', 'button');
			}
		});

		$('.wkcv-term-popup, .wkcv-policy-popup').each(function () {
			var $popup = $(this);
			var $contentElem = $popup.find('.wkcv-popup-content');

			$contentElem.each(function () {
				var $this = $(this);
				var htmlContent = $this.html();

				// If the element is a <p> tag, replace <p> tag with <div> tag to avoid browser auto-close DOM bugs
				if ($this.is('p')) {
					var $newDiv = $('<div>').attr('class', $this.attr('class') || '').attr('style', $this.attr('style') || '').html(htmlContent);
					$this.replaceWith($newDiv);
					$this = $newDiv;
				}

				// Decode escaped HTML if present
				var currentHtml = $this.html();
				if (currentHtml && (currentHtml.indexOf('&lt;') !== -1 || currentHtml.indexOf('&gt;') !== -1)) {
					var textarea = document.createElement('textarea');
					textarea.innerHTML = currentHtml;
					var decodedHtml = textarea.value;

					if (decodedHtml && decodedHtml !== currentHtml) {
						$this.html(decodedHtml);
					}
				}

				// Clean up empty leading/trailing paragraph tags or whitespace nodes
				$this.find('p').each(function () {
					var text = $(this).text().trim();
					var innerHtml = $(this).html().trim();
					if (!text && (!innerHtml || innerHtml === '<br>' || innerHtml === '&nbsp;')) {
						$(this).remove();
					}
				});
			});
		});
	}

	// Intercept click on close buttons to prevent any form submit or HTML5 validation popups
	$(document).on('click', '.wkcv-close-modal, .wkcv-hide-terms, .wkcv-hide-policies', function (e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
		$(this).closest('.wkcv-term-popup, .wkcv-policy-popup').css('display', 'none');
		return false;
	});

	// Strip the "Refunded" option from the vendor order-status dropdown so a
	// vendor cannot select it (which would issue a full refund). Scoped to the
	// #mp-status select, which only exists on the vendor order view.
	function hideRefundedStatusOption() {
		var $status = $('#mp-status');
		if (!$status.length) {
			return;
		}
		$status.find('option[value="wc-refunded"]').not(':selected').remove();
	}

	// Run on DOM ready
	$(document).ready(function () {
		fixModalButtonsAndHtml();
		hideRefundedStatusOption();
	});

	// Run when modal open triggers are clicked
	$(document).on('click', '#wkcv-read-term-condition, #wkcv-read-privacy, .wkcv-read-term-condition, .wkcv-read-privacy', function () {
		fixModalButtonsAndHtml();
		setTimeout(fixModalButtonsAndHtml, 50);
		setTimeout(fixModalButtonsAndHtml, 200);
	});

	// MutationObserver to watch for style or display changes on popups
	if (typeof MutationObserver !== 'undefined') {
		var targetPopups = document.querySelectorAll('.wkcv-term-popup, .wkcv-policy-popup');
		if (targetPopups.length) {
			var observer = new MutationObserver(function () {
				fixModalButtonsAndHtml();
			});
			targetPopups.forEach(function (popup) {
				observer.observe(popup, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true });
			});
		}
	}
});
